import ACTIONS from "../../constants/actions";

const initialState = {
	banners         : [],
	fetching        : true
};

export default function topTourneys(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.TOP_TOURNEYS.GET:
			const newState = {
				banners:action.data,
				fetching:false
			};

			return Object.assign({}, {...state, ...newState});
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/top-tourneys.js